// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__y45Bd","wrapper":"PriceList_wrapper__9g2cG","footerStyle":"PriceList_footerStyle__m4Gxi"};